<div style="background-color: white;">
	<div class="modal-header">
		<button (click)="shouldUpdateSynthesis(true)" aria-label="Close" class="close" type="button">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		{{ messageToShow | translate }}
	</div>
	<div class="modal-footer">
		<button (click)="shouldUpdateSynthesis(true)" class="btn btn-primary mr-1" type="button">Ok</button>
	</div>
</div>